export default "__VITE_ASSET__dT87HhC9__"